<template>
  <v-content>
    <v-container fluid>
      <v-layout>
        <v-flex>

          <v-card>
            <v-toolbar flat class="card-bar">
              <v-toolbar-title>Rawdata Writer</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
              <v-textarea
                class="monospace-input"
                v-model="hexInput"
                label="Input"/>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" large
                @click="write()">Write</v-btn>
              <v-switch
                class="ml-5"
                label="Pretty-print"
                v-model="pretty"/>
            </v-card-actions>
          </v-card>

          <v-card class="mt-3" v-if="output != null">
            <v-card-text>
              <pre v-if="pretty">{{output | prettyHex}}</pre>
              <pre v-else>{{output | hex}}</pre>
            </v-card-text>
          </v-card>

        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import {processRawdataHex} from 'horus-writer/from-hex'
import brush from 'brush'
import moment from 'moment'

export default {
  data() {
    return {
      x: moment().add(-5, 'd').toDate(),
      hexInput: `# Sample:
<%= header({}) %>
<%= nLapses(10, {rpm: 100}) %>
<%= footer({}) %>
      `,
      output: null,
      pretty: true
    }
  },
  methods: {
    write() {
      let globals = {},
          opts = {binary: true}

      this.output = processRawdataHex(this.hexInput,
        globals, opts)
    },
  },
  filters: {
    prettyHex(bytes) {
      if ( bytes == null ) return ''
      return brush.toHex(bytes, {
        prettyPrint: true, bytesPerLine: 16
      })
    }
  }
}
</script>

<style>
</style>
